var _path, _path2, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGrisRetirerCouv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,2.9l0.6-0.7L20.5,1L1.1,22.3l1.3,1.2l0.5-0.6c0.4,0.4,1,0.6,1.6,0.6h16.1c1.3,0,2.3-1,2.3-2.3V5.1 C22.9,4.1,22.2,3.1,21.2,2.9z M20.6,21.2H4.5l0,0l7.3-8V18l-0.2,0.3l-1.4,0.1V19H15v-0.7l-1.3-0.1L13.6,18v-6.9L17,7.4h1.3V6 l0.9-0.9h1.5V21.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,17.1v-12h2.3v2.3h6.6l4.2-4.6h-1.8c-0.6-1.8-2.6-2.7-4.4-2.1c-1,0.3-1.8,1.1-2.1,2.1H4.5c-1.3,0-2.3,1-2.3,2.3v14.5 L4.5,17.1z M12.6,2.8c0.6,0,1.1,0.5,1.1,1.2c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.2C11.4,3.3,11.9,2.8,12.6,2.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "9.7,11.4 9.8,11.3 10.7,10.3 9.7,10.6 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGrisRetirerCouv);
export default __webpack_public_path__ + "static/media/action_gris_retirer-couv.4a3a4040.svg";
export { ForwardRef as ReactComponent };